import { HTMLAttributes, ReactNode } from 'react';
import styled, { css } from 'styled-components';

type TitleWrapperProps = HTMLAttributes<HTMLDivElement> & { children?: ReactNode };

export const TitleWrapper = styled.div<TitleWrapperProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

type WrapperProps = HTMLAttributes<HTMLDivElement> & { children?: ReactNode };

export const Wrapper = styled.div<WrapperProps>`
  padding: 10px 25px 20px 40px;
  margin-bottom: 15px;
`;

type ItemProps = HTMLAttributes<HTMLDivElement> & { children?: ReactNode; bold?: boolean };

export const Item = styled.div<ItemProps>`
  ${({ bold }) =>
    bold &&
    css`
      font-weight: 500;
    `}
`;
